export const projects = [
  {
    id: 7,
    title: "Retail Banking",
    description: "A web application with the ability to create bank customers and maintain their accounts. It also supports generating reports of transactions that are being made by customers.",
    details: ["Programming Language - Python", "Framework Used - Flask", "Database Used - SQLITE3"],
    image: "img/RetailBanking.png",
  },
  {
    id: 6,
    title: "Hospital Management System",
    description:
      "A web application with the ability to register patients, maintain medicines stock in the pharmacy and generate bill for the medicines purchased.",
    details: ["Programming Language - Python ", " Framework Used - Flask ", " Database Used - SQLITE3"],
    image: "img/HospitalManagementSystem.png",
  },
  {
    id: 5,
    title: "Image Captioning",
    description: "Generating a caption for the given image using CNN and RNN. The model has been trained on the Flickr8K Dataset.",
    details: ["Programming Language - Python ", " Libraries used - Tensorflow, Keras, Pandas, Numpy, Flask Web Framework"],
    image: "img/image_captioning.png",
  },
  {
    id: 4,
    title: "Examination Management System",
    description: "A web application for our college's examination branch and is able to create exam notifications, generate fee receipts and generate halltickets for the students.",
    details: ["Scripting Language - PHP ", " Web Framework - CodeIgniter (MVC Architecture)", "Libraries used -  DOMPDF, CrudIgniter"],
    image: "img/examination_branch.png",
  },
  {
    id: 3,
    title: "Anurag's Skill Club",
    description: "An android app for our college's Skills Club. Using this app students can enroll into various events that are being conducted by this club. Admin login has provided with features like enrolling/unenrolling students, sending notifications to students, etc.",
    details: ["Programming Language - Java ", " IDE used - Android Studio", "Database used - Firebase"],
    image: "img/skillsclub.png",
  },
  {
    id: 2,
    title: "International Conference Website",
    description: "A website for an International Conference ICACII-2019, organized by Anurag Group of Institutions. ",
    details: ["Scritping Language - PHP ", "Web Framework - CodeIgniter (MVC Architecture)", "CSS Framework -  Bootstrap"],
    link: "http://anuragcdtc.com/icacii/ICACII/",
    image: "img/icacii.png",
  },
  {
    id: 1,
    title: "Anurag’s Student Course Registration ",
    description: "Center for Development of Technical Competencies (CDTC) is a student enrollment site into various clubs and courses offered by Anurag Group of Institutions.",
    details: ["Programming Language - PHP ", "Web Framework - CodeIgniter (MVC Architecture)"],
    link: "http://anuragcdtc.com/",
    image: "img/cdtc.png",
  },

  {
    id: 0,
    title: "Women's Club Website",
    description: "A website for our college's women's club designed using HTML and CSS",
    details: ["Scripting Language - PHP ", "CSS Framework -  Bootstrap"],
    // link: "http://anuragcdtc.com/womensclub/",
    image: "img/womensclub.png",
  },
];
